import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const STORAGE_KEY = "cia_cookie_consent";

export default function CookieBanner() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) setVisible(true);
  }, []);

  const setConsent = (level) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ level, ts: Date.now() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-4 left-4 right-4 md:left-6 md:right-6 z-50 bg-[#0A0A0A] text-white border border-[#FFD600] p-5 md:p-6 max-w-3xl md:mx-auto"
      data-testid="cookie-banner"
      role="dialog"
      aria-label="Cookie consent"
    >
      <div className="flex flex-col md:flex-row gap-4 items-start md:items-center justify-between">
        <div className="flex-1">
          <div className="font-mono-mark text-[10px] text-[#FFD600]">
            {t("cookie.mark", "PRIVACIDAD · COOKIES")}
          </div>
          <p className="font-mono-data text-sm mt-2 leading-relaxed">
            {t(
              "cookie.body",
              "Usamos cookies esenciales para que la plataforma funcione y cookies analíticas (opcionales) para mejorarla. Puedes aceptar todas, rechazar las no esenciales, o leer más."
            )}{" "}
            <Link to="/legal/cookies" className="underline hover:text-[#FFD600]">
              {t("cookie.learn", "Saber más")}
            </Link>
          </p>
        </div>
        <div className="flex gap-2 shrink-0">
          <button
            onClick={() => setConsent("essential")}
            className="px-4 py-3 border border-white/40 text-white font-mono-mark text-[10px] hover:bg-white hover:text-[#0A0A0A]"
            data-testid="cookie-reject"
          >
            {t("cookie.reject", "SOLO ESENCIALES")}
          </button>
          <button
            onClick={() => setConsent("all")}
            className="px-4 py-3 bg-[#FFD600] text-[#0A0A0A] font-mono-mark text-[10px] hover:bg-white"
            data-testid="cookie-accept"
          >
            {t("cookie.accept", "ACEPTAR TODAS")}
          </button>
        </div>
      </div>
    </div>
  );
}
